<template>
    <div
        v-if="checkPermission('UDWWB_SCHEDULE')"
        :class="['page-myschedule', { 'guide-schedule-container': steps.step4 }]"
    >
        <div class="headerBox">
            <div class="monthBox">
                <el-date-picker
                    v-model="searchParam.month"
                    prefix-icon="noIcon"
                    type="month"
                    :clearable="false"
                    size="mini"
                    width="80"
                    format="yyyy 年 MM 月"
                    :editable="false"
                    :picker-options="pickerOptions"
                    @change="changeDate"
                ></el-date-picker>
                <span v-if="isToday || pageLevelBei !== pageLevel" class="todayBtnCss" @click="todayBtn">今天</span>
            </div>
        </div>
        <div class="dailyBox">
            <div class="dailyWild">
                <div class="weekBox">
                    <div>周一</div>
                    <div>周二</div>
                    <div>周三</div>
                    <div>周四</div>
                    <div>周五</div>
                    <div>周六</div>
                    <div>周日</div>
                </div>
                <div ref="dateBox" class="dateBox" :style="computedLeft">
                    <div v-for="(item, index) in dateList" :key="index" class="dayBox" @click="selectDate(item)">
                        <div
                            class="insideBox"
                            :class="
                                `${item.num == selectDay && !item.disabledSign ? 'activeDate' : ''} ${
                                    item.disabledSign ? 'disableCss' : ''
                                } ${currentDay == item.num && !item.disabledSign ? 'currentDayCss' : ''}`
                            "
                        >
                            {{ item.num }}
                        </div>
                        <div v-if="item.num != selectDay && !item.disabledSign" class="signCircle">
                            <i v-if="item.haveSchdule" class="greenCircle"></i>
                        </div>
                    </div>
                </div>
            </div>
            <i
                class="leftIcon el-icon-caret-left"
                :class="`${pageLevel == 0 ? 'disableCss' : ''}`"
                @click="turnLeft"
            ></i>
            <i
                class="rightIcon el-icon-caret-right"
                :class="`${pageLevel == maxPageLevel ? 'disableCss' : ''}`"
                @click="turnRight"
            ></i>
        </div>
        <div v-loading="dataLoading" class="dailyContentBox">
            <el-scrollbar
                v-if="schuleList.length !== 0"
                ref="scrollBar6"
                class="components-content-main left-box overflow-x-hidden overflow-y-visible"
            >
                <div v-for="(item, index) in schuleList" :key="index" class="date-item">
                    <div class="title-box">
                        <span class="active">[日程]</span
                        ><span class="date-title"
                            >{{ item.summary }}
                            <span class="addr" @click="scheduleDetail(item)">详情</span>
                        </span>
                    </div>
                    <div class="date-box">
                        <span> {{ formatCurrentDate(item) }}</span>
                        <!-- <span class="detail">{{ item.calendarDetailResultDto.roomInfo }}</span> -->
                    </div>
                </div>
            </el-scrollbar>
            <div v-else class="noDataInfo ">
                <no-empty>暂无数据</no-empty>
            </div>
        </div>
        <schdule-detail-dialog ref="schduleDetailDialog"></schdule-detail-dialog>
    </div>
</template>
<script>
import { getFeiShuCalendarListV2 } from "@/api";
import NoEmpty from "@/components/no-empty";
import { getLocalStorage } from "@/libs/mUtils";
import SchduleDetailDialog from "./components/schdule-detail-dialog";
import { mapState } from "vuex";
export default {
    components: {
        NoEmpty,
        [SchduleDetailDialog.name]: SchduleDetailDialog,
    },
    data() {
        return {
            scheduleDialogShow: false,
            loading: true,
            // 查询日程参数
            searchParam: {
                month: new Date(),
                userId: "",
            },
            //日历渲染数据
            dateList: [],
            //选中日期号数
            selectDay: new Date().getDate(),
            // 当前日历页码
            pageLevel: 0,
            pageLevelBei: 0,
            // 当月最大页码
            maxPageLevel: 1,
            // 当前是那哪一天
            currentDay: 1,
            // 搜索出的人员列表
            selectPerson: [],
            // 权限设置弹框
            authorDialog: false,
            // 当月日程会议标识
            scheduleArr: {},
            // 日程列表
            schuleList: [],
            // 宽度结算
            windowW: 0,
            pageType: "add",
            editPart: "EDIT_NO",
            scheduleId: "",
            orderDialogVisible: false,
            clickPersonName: "",
            startClickClock: "",
            endClickClock: "",
            clickDate: "",
            clickDate2: "",
            refuseScheduleVisible: false,
            refuseReason: "",
            curOrderSchduleId: "",
            dataLoading: false,
            dealDialogVisible: false,
            shadeShow: false, //详情遮罩
            scDetail: "",
            curItemDetail: "",
            pickerOptions: {
                // 限制日期
                disabledDate: this.disabledDate,
            },
        };
    },
    computed: {
        isToday() {
            let now = this.$mUtils.formatDate(new Date().getTime(), "yyyy-MM-dd");
            let nowStr = this.getDateStr(this.searchParam.month, this.selectDay);
            let sign = true;
            if (now == nowStr) {
                sign = false;
            }
            return sign;
        },
        computedLeft() {
            return {
                left: -this.windowW * this.pageLevel + "px",
            };
        },
        ...mapState({
            switch: (state) => state.guide.switch,
            steps: (state) => state.guide.steps,
        }),
    },
    created() {
        this.loading = false;
        this.initDailySign(new Date()).then(() => {
            this.getInitData(new Date());
            this.initSchedule(this.selectDay);
        });
    },
    mounted() {
        this.$nextTick(() => {
            this.windowW = this.$refs.dateBox && this.$refs.dateBox.offsetWidth;
        });
        let that = this;
        window.addEventListener("resize", that.setWindowH);
        this.$eventBus.$on("resizeScrollbar", () => {
            this.$nextTick(() => {
                try {
                    this.$refs.scrollBar6.update();
                } catch (e) {
                    console.error(e);
                }
            });
        });
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.setWindowH);
    },
    methods: {
        formatCurrentDate(data) {
            if (data.startTime.date || data.endTime.date) {
                return "全天";
            } else {
                return `${this.$dayjs(Number(`${data.startTime.timestamp}000`)).format(
                    "YYYY年MM月DD日 HH:mm"
                )}-${this.$dayjs(Number(`${data.endTime.timestamp}000`)).format("YYYY年MM月DD日 HH:mm")}`;
            }
        },
        todayBtn() {
            this.selectDay = new Date().getDate();
            this.searchParam.month = new Date();
            this.initDailySign(new Date(), this.searchParam.userId).then(() => {
                this.getInitData(new Date());
                this.initSchedule(this.selectDay);
            });
        },
        disabledDate(time) {
            // 禁用4月之前的数据
            return time.getTime() < 1617206400000;
        },
        setWindowH() {
            this.$nextTick(() => {
                this.windowW = this.$refs.dateBox && this.$refs.dateBox.offsetWidth;
            });
        },
        initDailySign(date, userId) {
            let currentMonthLastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
            let startDate = this.getDateStr(date, 1) + " 00:00:00";
            let endDate = this.getDateStr(date, currentMonthLastDay) + " 00:00:00";
            let user = getLocalStorage("user");
            let auth_user = this.$store.state.user.oauth.userId || user.oauth.userId;
            return new Promise((resolve) => {
                this.$axios
                    .get("/schedule/management/listByMonth", {
                        userId: userId ? userId : auth_user,
                        startDate,
                        endDate,
                    })
                    .then((res) => {
                        this.scheduleArr = res.body;
                        resolve();
                    });
            });
        },
        getDateStr(dateObj, dayNum) {
            let year = dateObj.getFullYear();
            let month = dateObj.getMonth() + 1;
            let day = dayNum ? dayNum : dateObj.getDate();
            if (month < 10) {
                month = "0" + month;
            }
            if (day < 10) {
                day = "0" + day;
            }
            return year + "-" + month + "-" + day;
        },
        initSchedule(dayNum) {
            let startDate = this.getDateStr(this.searchParam.month, dayNum) + " 00:00:00";
            let endDate = this.getDateStr(this.searchParam.month, dayNum) + " 23:59:59";
            let obj = {};
            obj.userName = getLocalStorage("user").oauth.userName || "";
            obj.startDate = startDate || `${this.$mUtils.getcurrentDate(new Date())} 00:00:00`;
            obj.endDate = endDate || `${this.$mUtils.getcurrentDate(new Date())} 23:59:59`;
            this.getCalendarList(obj);
        },
        async getCalendarList(params) {
            this.dataLoading = true;
            try {
                const { code, message, body } = await getFeiShuCalendarListV2(params);
                if (code === "0000") {
                    this.schuleList = body;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.dataLoading = false;
        },
        scheduleDetail(item) {
            const { calendarId, eventId, summary, description } = item;
            this.$refs.schduleDetailDialog.show({
                calendarId,
                eventId,
                summary,
                description,
                userName: getLocalStorage("user").oauth.userName || "",
                dateString: this.formatCurrentDate(item),
            });
        },
        turnLeft() {
            if (this.pageLevel === 0) {
                return;
            } else {
                this.pageLevel--;
            }
        },
        turnRight() {
            if (this.maxPageLevel === this.pageLevel) {
                return;
            } else {
                this.pageLevel++;
            }
        },
        selectDate(item) {
            if (item.disabledSign) {
                return;
            } else {
                this.initSchedule(item.num);
            }
            this.selectDay = item.num;
        },
        changeDate(nowDate) {
            this.pageLevel = 0;
            this.initDailySign(nowDate).then(() => {
                this.getInitData(nowDate);
            });
            this.initSchedule(1);
        },
        getInitData(nowDate) {
            let currentDate = nowDate;
            this.selectDay = nowDate.getDate();
            this.currentDay = nowDate.getDate();

            // 获取上个月总共多少天
            let lastMonthLastDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();

            // 获取当前月总共多少天
            let currentMonthLastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
            // 上个月最后一天星期几
            let firstSign = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDay();
            // 下个月第一天星期几
            let lastSign = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1).getDay();
            //周天转为7处理
            if (firstSign == 0) {
                firstSign = 7;
            }
            if (lastSign == 0) {
                lastSign = 7;
            }
            let arr = [];
            for (let i = 0; i < firstSign; i++) {
                arr.unshift({
                    num: lastMonthLastDay - i,
                    disabledSign: true,
                });
            }
            for (let j = 1; j <= currentMonthLastDay; j++) {
                let haveSchdule = false;
                if (
                    this.scheduleArr[j + ""] &&
                    (this.scheduleArr[j + ""].indexOf("schedule") !== -1 ||
                        this.scheduleArr[j + ""].indexOf("meeting") !== -1)
                ) {
                    haveSchdule = true;
                }

                arr.push({
                    num: j,
                    active: false,
                    disabledSign: false,
                    haveSchdule: haveSchdule,
                });
            }
            // 下个月一号是周一就不做添加
            if (lastSign !== 1) {
                for (let k = 1; k <= 8 - lastSign; k++) {
                    arr.push({
                        num: k,
                        disabledSign: true,
                    });
                }
            }
            //设置当前默认翻页数；
            arr.map((item, index) => {
                if (!item.disabledSign && item.num == this.currentDay) {
                    this.pageLevel = parseInt(index / 7);
                    this.pageLevelBei = parseInt(index / 7);
                }
            });
            // 获取当月跨周数用于 翻页
            this.maxPageLevel = parseInt(arr.length / 7) - 1;
            this.dateList = arr;
        },
    },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
